export enum RequestHost {
    MAINDOMAIN = "MAINDOMAIN",
    CUSTOMDOMAIN = "CUSTOMDOMAIN",
    SUBDOMAIN = "SUBDOMAIN"
}

// Tracks whether we are on a custom domain / subdomain / original domain
export const XRequestHostHeader = "x-authory-request-host";
export const XRequestHostSlug = "x-authory-request-host-slug";
